module.exports = __webpack_public_path__ + "static/WernerA-d9442f48e41dd8d83c31e3d2f7501b9f.gif";